const NotFound: React.FC = () => {
    return (
        <div id='NotFoundPage' className='page'>
            <h2>404 Not Found.</h2>
            <p>ページが見つかりません。</p>
        </div>
    );
};

export default NotFound;
